import { render, staticRenderFns } from "./PaymentHistoryList.vue?vue&type=template&id=5dd4e4f2&"
import script from "./PaymentHistoryList.vue?vue&type=script&lang=js&"
export * from "./PaymentHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports